import React from "react";
import { Provider } from "react-redux";

import store from "../../state/store";
import AppStarter from "../AppStarter";

import "./App.css";

function App() {
  return (
    <Provider store={store}>
      <AppStarter />
    </Provider>
  );
}

export default App;
